import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export interface UnarchiveBatchResult {
  value: string;
  name: string;
  mrn?: string;
  searchValue?: string;
  templateType: string;
}

interface HookProps {
  search: string;
}

const searchArchivedBatches = async ({ search }: HookProps): Promise<UnarchiveBatchResult[]> => {
  try {
    return await request({
      path: `batches/search-archived-batches`,
      method: 'POST',
      authenticate: true,
      dataObject: { search },
    });
  } catch (error) {
    showErrorToast(error, 'Failed to fetch the batch details');
  }
};

export const useSearchArchivedBatches = ({ search }: HookProps) =>
  useQuery({
    queryKey: ['archived-batches', search],
    queryFn: async () => searchArchivedBatches({ search }),
    enabled: !!search,
    placeholderData: [],
  });
